import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Toolbar from "../navigation/Toobar";
import Chat from "../components/common/Chat";
import Footer from "../layout/Footer";
import Header from "../layout/Header";

const prizes = ['৳7', '৳14', '৳21', '৳178', '৳28', '৳35', '৳999', '৳9999'];
const restrictedPrizes = new Set(['৳178', '৳999', '৳9999']);

function LuckySpain({globalData})
{
    const navigate = useNavigate();
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    const wheelRef = useRef(null);
    
    const [spinning, setSpinning] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [wonAmount, setWonAmount] = useState(null);
    const [showResult, setShowResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [transactionData, setTransactionData] = useState(null);
    
    const sliceCount = prizes.length;
    const sliceAngle = 360 / sliceCount;
    
    // Get allowed indexes (exclude restricted prizes)
    const allowedIndexes = prizes
        .map((p, i) => (restrictedPrizes.has(p) ? -1 : i))
        .filter((i) => i !== -1);

    // Get userData and transactions from globalData
    const userData = globalData?.userData || null;
    const transactions = globalData?.transactions || [];

    // Check if user has made a successful deposit in the last 3 days
    const hasDepositLast3Days = useMemo(() => {
      if (!Array.isArray(transactions) || transactions.length === 0) return false;
        const threeDaysAgo = new Date();
        threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
      const isSuccess = (t) => {
        if (!t) return false;
        // This codebase commonly uses `key`: 1=success, 0=pending, 2=fail.
        if (t.key != null) return String(t.key) === '1';
        // Fallbacks for other APIs
        if (t.status != null) return String(t.status).toLowerCase() === 'success';
        if (t.success != null) return Boolean(t.success);
        return false;
      };

      const isDeposit = (t) => {
        const action = (t?.action ?? t?.type ?? t?.transaction_type ?? '').toString().toLowerCase();
        return action === 'deposit';
      };

      const parseDate = (value) => {
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
      };

      return transactions.some((t) => {
        if (!isDeposit(t) || !isSuccess(t)) return false;
        const txDate = parseDate(t.created_at ?? t.date ?? t.createdAt);
        if (!txDate) return false;
        return txDate >= threeDaysAgo;
      });
    }, [transactions]);

    const spin = useCallback(async () => {
        if (spinning) {
            console.log('Already spinning, please wait...');
            return;
        }
        
        if (allowedIndexes.length === 0) {
            setErrorMessage('No prizes available. Please try again later.');
            setShowResult(true);
            return;
        }
        
        // 1. Login check
        if (!token) {
            setErrorMessage('You must be logged in to spin.');
            setShowResult(true);
            return;
        }

        // Ensure we have latest user data from server
        if (!userData) {
          setErrorMessage('Loading your account info. Please try again in a moment.');
          setShowResult(true);
          return;
        }

        // 2. Phone verification check (from server userData)
        const isVerified = userData?.session_id == 1;
        if (!isVerified) {
            setErrorMessage('Please verify your phone number first.');
            setShowResult(true);
            return;
        }

        // 3. Deposit check (from server transactions - last 3 days)
        if (!hasDepositLast3Days) {
            setErrorMessage('You must deposit successfully in the last 3 days to spin.');
            setShowResult(true);
            return;
        }

        // All checks passed - start spinning
        setSpinning(true);
        setShowResult(false);
        setErrorMessage(null);
        
        // Pick a random allowed prize index
        const targetIndex = allowedIndexes[Math.floor(Math.random() * allowedIndexes.length)];
        const prizeLabel = prizes[targetIndex];
        const prizeAmount = parseInt(String(prizeLabel).replace(/[^\d]/g, ''), 10);
        
        // Calculate rotation
        const centerAngle = targetIndex * sliceAngle + sliceAngle / 2;
        const normalize = (angle) => ((angle % 360) + 360) % 360;
        const current = normalize(rotation);
        const desired = normalize(360 - centerAngle);
        let baseDelta = desired - current;
        if (baseDelta < 0) baseDelta += 360;
        const extraTurns = 5 + Math.floor(Math.random() * 3);
        const totalDelta = extraTurns * 360 + baseDelta;
        
        setRotation((prev) => prev + totalDelta);
        
        // Wait for spin animation to complete
        setTimeout(async () => {
            setWonAmount(prizeLabel);
            
            // Call API to record the spin
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/free/spin`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({ amount: prizeAmount }),
                });
                
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    setErrorMessage(errorData.message || 'Something went wrong. Please try again.');
                    setShowResult(true);
                    setSpinning(false);
                    return;
                }
                
                const data = await res.json();
                setTransactionData(data.transaction);
                setWonAmount(`৳${data.transaction.amount}`);
                setShowResult(true);
                setSpinning(false);
            } catch (err) {
                console.error('Free spin error:', err);
                setErrorMessage('Network error. Please try again.');
                setShowResult(true);
                setSpinning(false);
            }
        }, 5000); // Match the CSS transition duration
    }, [spinning, allowedIndexes, rotation, sliceAngle, token, userData, hasDepositLast3Days]);

    return(
        <div className="v-application--wrap">
  <div>
    {/**/}
   <Header/>
    
    
    
    <div className="body">
      <div data-v-4f5f518c className={`roulette${showResult ? ' roulette-popupOpen' : ''}`}>
        <div data-v-4f5f518c className="roulette_wrap">
          <div data-v-4f5f518c className="roulette_main">
            <div data-v-4f5f518c className="roulette-period">
              Free Daily Spin
            </div>
            <div
              data-v-4f5f518c
              className="roulette_main_wrap roulette_P8_N8 luckywheel"
            >
              <ul
                data-v-4f5f518c
                ref={wheelRef}
                className="roulette_main_part roulette_main_part-8 luckywheel"
                style={{
                  transform: `rotate(${rotation}deg)`,
                  transition: spinning ? 'transform 5s cubic-bezier(.17,.67,.32,1)' : 'none',
                }}
              >
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳7
                  </span>
                </li>
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳14
                  </span>
                </li>
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳21
                  </span>
                </li>
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳178
                  </span>
                </li>
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳28
                  </span>
                </li>
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳35
                  </span>
                </li>
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳999
                  </span>
                </li>
                <li data-v-4f5f518c className="roulette_main_part_list">
                  <div data-v-4f5f518c className="roulette_main_part_color" />
                  <span data-v-4f5f518c className="roulette_main_part_award">
                    ৳9999
                  </span>
                </li>
              </ul>
              <div
                data-v-4f5f518c
                className="roulette_main_btn"
                onClick={spin}
                style={{
                  backgroundImage:
                    'url("https://jiliwin.9terawolf.com/images/bigtaka/wof/spinbutton.png")',
                  backgroundPosition: "center center",
                  backgroundSize: "cover",
                  cursor: spinning ? 'not-allowed' : 'pointer',
                  opacity: spinning ? 0.7 : 1,
                }}
              />

            </div>
            <div data-v-4f5f518c className="roulette_main_coin">
              <span data-v-4f5f518c className="roulette_main_coinWrap">
                <img
                  data-v-4f5f518c
                  src="https://jiliwin.9terawolf.com/images/wof/1.png"
                  className="roulette_main_coin_1"
                />
              </span>
              <span data-v-4f5f518c className="roulette_main_coinWrap">
                <img
                  data-v-4f5f518c
                  src="https://jiliwin.9terawolf.com/images/wof/3.png"
                  className="roulette_main_coin_2"
                />
              </span>
              <span data-v-4f5f518c className="roulette_main_coinWrap">
                <img
                  data-v-4f5f518c
                  src="https://jiliwin.9terawolf.com/images/wof/2.png"
                  className="roulette_main_coin_3"
                />
              </span>
              <span data-v-4f5f518c className="roulette_main_coinWrap">
                <img
                  data-v-4f5f518c
                  src="https://jiliwin.9terawolf.com/images/wof/4.png"
                  className="roulette_main_coin_4"
                />
              </span>
              <span data-v-4f5f518c className="roulette_main_coinWrap">
                <img
                  data-v-4f5f518c
                  src="https://jiliwin.9terawolf.com/images/wof/5.png"
                  className="roulette_main_coin_5"
                />
              </span>
              <span data-v-4f5f518c className="roulette_main_coinWrap">
                <img
                  data-v-4f5f518c
                  src="https://jiliwin.9terawolf.com/images/wof/6.png"
                  className="roulette_main_coin_6"
                />
              </span>
            </div>
          </div>
          <div
            data-v-4f5f518c
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <button
              data-v-4f5f518c
              type="button"
              className="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default luckywheelbtn active"
              style={{ transform: "scale(1.1)" }}
            >
              <span className="v-btn__content" />
            </button>
            <button
              data-v-4f5f518c
              type="button"
              className="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default luckywheelEx1btn"
            >
              <span className="v-btn__content" />
            </button>
            <button
              data-v-4f5f518c
              type="button"
              className="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default luckywheelEx2btn"
            >
              <span className="v-btn__content" />
            </button>
          </div>
          <div data-v-4f5f518c className="roulette_minor">
            <ul data-v-4f5f518c className="roulette_awards">
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38211.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳7
                  </div>
                </div>
              </li>
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38222.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳14
                  </div>
                </div>
              </li>
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38233.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳21
                  </div>
                </div>
              </li>
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38243.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳178
                  </div>
                </div>
              </li>
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38277.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳28
                  </div>
                </div>
              </li>
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38666.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳35
                  </div>
                </div>
              </li>
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38288.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳999
                  </div>
                </div>
              </li>
              <li data-v-4f5f518c className="roulette_awards_item">
                <div data-v-4f5f518c>
                  <div data-v-4f5f518c className="roulette_awards_medals" />
                  <div data-v-4f5f518c className="roulette_awards_prize">
                    <img
                      data-v-4f5f518c
                      src="https://jiliwin.9terawolf.com/cms/bigtaka/image/668b59dd38201.png"
                    />
                  </div>
                  <div data-v-4f5f518c className="roulette_awards_text">
                    ৳9999
                  </div>
                </div>
              </li>
            </ul>
            <div data-v-4f5f518c className="roulette_winner">
              <div data-v-4f5f518c className="roulette_winner_wrap">
                <div
                  data-v-4f5f518c
                  className="roulette_winner_head winnerList"
                >
                  <div data-v-4f5f518c className="roulette_winner_headItem">
                    Winner's list
                  </div>
                  <div data-v-4f5f518c className="roulette_winner_headItem">
                    Winning record
                  </div>
                  <div
                    data-v-4f5f518c
                    className="roulette_winner_headCursor leftMost"
                  />
                </div>
                <div data-v-4f5f518c className="roulette_winner_slider">
                  <ul data-v-4f5f518c className="roulette_winner_list">
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>md90****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        33.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>maal****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>maal****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>sahela******</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        33.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01611*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>bag***</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>raf***</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>jam***</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>babu****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01846*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01750*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdma****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>saifu*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        22.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdalm*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>sami****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        22.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>moz***</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>shon****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>joy***</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01767*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>paris*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        22.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdti****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        22.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01340*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>ruve****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01340*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01340*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdnur*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>rash****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        22.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01897*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>bhum****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>rabb****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        22.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01710*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01710*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>shiha*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        33.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>01812*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>sujo****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdba****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mhsh****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdri****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>sarm****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>soton*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        22.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>soton*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>mdras*****</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                    <li data-v-4f5f518c className="roulette_winner_listItem">
                      <span data-v-4f5f518c className="roulette_winner_date">
                        2025-11-01
                      </span>
                      <span data-v-4f5f518c>ali***</span>
                      <span data-v-4f5f518c className="roulette_winner_prize">
                        11.00
                      </span>
                    </li>
                  </ul>
                  <ul
                    data-v-4f5f518c
                    className="roulette_winner_list"
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            </div>
            <div data-v-4f5f518c className="roulette_rule">
              <h3 data-v-4f5f518c className="roulette_rule_title">
                Terms &amp; Conditions:{" "}
              </h3>
              <p data-v-4f5f518c className="rouletteRule_text" />
              <p data-v-4f5f518c>
                <strong data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                    BIGTAKA LUCKY WHEEL
                  </span>
                </strong>
              </p>
              <p data-v-4f5f518c>
                <strong data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                    Spin Lucky Wheel to get extra CASH!
                  </span>
                </strong>
              </p>
              <p data-v-4f5f518c />
              <div data-v-4f5f518c className="luckyWheel-divWrapper">
                <div
                  data-v-4f5f518c
                  className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--dark"
                >
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-8">
                      <span data-v-4f5f518c>Member Types</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>All Members</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-8">
                      <span data-v-4f5f518c>Frequency</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>UNLIMITED</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-8">
                      <span data-v-4f5f518c>Bonus / Rebate Percentage</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>N/A</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-8">
                      <span data-v-4f5f518c>Max Bonus / Rebate</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳999</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-8">
                      <span data-v-4f5f518c>Game Providers</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>All Game Providers</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-8">
                      <span data-v-4f5f518c>Turnover Requirement</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>x1</span>
                    </div>
                  </div>
                </div>
              </div>
              <p data-v-4f5f518c>
                <strong data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                    How to get coins :
                  </span>
                </strong>
              </p>
              <p data-v-4f5f518c>
                1. Make a minimum deposit of ৳200. Every ৳100 you deposited get
                1 coin. Example: If you deposit ৳1000, you will get 10 coins
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  2. Daily check in , check in everyday and get coins for free.
                </span>
              </p>
              <p data-v-4f5f518c />
              <p data-v-4f5f518c>
                <strong data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                    Bonus Conditions:
                  </span>
                </strong>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  1. This promotion is applicable to All Game Providers.
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  2. There is no limitation how many times members can spin.
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  3. Members are required to fulfill a turnover amount x1 bonus
                  amount in order to transfer or withdraw.
                </span>
              </p>
              <p data-v-4f5f518c />
              <p data-v-4f5f518c>
                <strong data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                    Coins per spin:
                  </span>
                </strong>
              </p>
              <div data-v-4f5f518c className="luckyWheel-divWrapper">
                <div
                  data-v-4f5f518c
                  className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--dark"
                >
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>Wheel of Bronze</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>Wheel of Silver</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>Wheel of Gold</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>20 coins</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>60 coins</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>500 coins</span>
                    </div>
                  </div>
                </div>
              </div>
              <p data-v-4f5f518c />
              <div data-v-4f5f518c className="luckyWheel-divWrapper">
                <div
                  data-v-4f5f518c
                  className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--dark"
                >
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>Wheel of Bronze</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>Wheel of Silver</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>Wheel of Gold</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳1111</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳5555</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳88888</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳888</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳1222</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳18888</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳666</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳777</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳8888</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳222</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳444</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳3888</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳88</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳222</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳1888</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳33</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳88</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳888</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳22</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳55</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳444</span>
                    </div>
                  </div>
                  <div data-v-4f5f518c className="row row-border no-gutters">
                    <div data-v-4f5f518c className="col-border col col-4">
                      <span data-v-4f5f518c>৳11</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳33</span>
                    </div>
                    <div data-v-4f5f518c className="col-padding col col-4">
                      <span data-v-4f5f518c>৳222</span>
                    </div>
                  </div>
                </div>
              </div>
              <p data-v-4f5f518c />
              <p data-v-4f5f518c>
                <strong data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                    Terms &amp; Conditions:{" "}
                  </span>
                </strong>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  1. All promotion offers are limited to only one per person.
                  Any shared or same household address, IP address, email
                  address, telephone number,credit or debit card and/or
                  e-payment account, or shared device (e.g. school, public
                  library or workplace) are not allowed.
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  2. Members are not allowed to bet at the same time
                  (Banker/Player, Big/Small, Black/White, Single/Double, etc.) .
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  3. Any bets resulting in void, tie, canceled, or made on
                  opposite sides with the same outcome will not be counted as a
                  valid turnover . Members are not allowed to bet at the same
                  time and roulette (black small/red large) or more than 18
                  numbers. Only 1/4 from your total bets will be counted as
                  turnover for bets made on Roulette.
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  4. All bonuses are not allowed to be used to purchase FREE
                  GAMES, FREE SPINS or any similar type of feature. All bonus
                  funds, money won and deposited may be removed immediately if
                  member is suspected or caught.
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  5. Participating members must accept and comply with all the
                  terms mentioned above as well as all relevant rules and
                  regulations stated on the BigTaka app.
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  6. BigTaka reserves the right to freeze/block a members
                  account if suspected of any fraudulent or suspicious
                  activities.
                </span>
              </p>
              <p data-v-4f5f518c>
                <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                  7. BigTaka reserves the right to modify, cancel, suspend or
                  terminate the promotion and/or change the terms of the said
                  promotion at any time without prior notice.
                </span>
              </p>
              <p data-v-4f5f518c>
                <strong data-v-4f5f518c>
                  <span data-v-4f5f518c style={{ fontSize: "14px" }}>
                    General BIGTAKA Terms &amp; Conditions apply.
                  </span>
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div data-v-4f5f518c className="roulette_nav">
          <ul data-v-4f5f518c className="roulette_nav_wrap">
            <li data-v-4f5f518c className="roulette_nav_item">
              <a data-v-4f5f518c href="/" className="active">
                Home
              </a>
            </li>
          </ul>
        </div>
        <div data-v-4f5f518c className="roulette_popup" style={{ display: showResult ? 'flex' : 'none' }}>
          <div data-v-4f5f518c className="roulette_popup_wrap">
            <div data-v-4f5f518c className="roulette_popup_box">
              {errorMessage ? (
                <>
                  <p data-v-4f5f518c style={{ color: '#ff4444' }}>❌ {errorMessage}</p>
                </>
              ) : (
                <>
                  <p data-v-4f5f518c style={{ fontSize: '24px', marginBottom: '10px' }}>🎉 Congratulations!</p>
                  <h3 data-v-4f5f518c style={{ color: '#28a745', fontSize: '36px', margin: '15px 0' }}>You won {wonAmount}</h3>
                  {transactionData && (
                    <div style={{ 
                      background: 'rgba(255,255,255,0.1)', 
                      borderRadius: '10px', 
                      padding: '15px', 
                      margin: '15px 0',
                      textAlign: 'left'
                    }}>
                      <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <span style={{ color: '#aaa' }}>Previous Balance:</span> 
                        <span style={{ color: '#fff', marginLeft: '10px' }}>৳{transactionData.before_balance}</span>
                      </p>
                      <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <span style={{ color: '#aaa' }}>Amount Won:</span> 
                        <span style={{ color: '#28a745', marginLeft: '10px' }}>+৳{transactionData.amount}</span>
                      </p>
                      <p style={{ margin: '5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                        <span style={{ color: '#aaa' }}>New Balance:</span> 
                        <span style={{ color: '#f1c40f', marginLeft: '10px' }}>৳{transactionData.after_balance}</span>
                      </p>
                    </div>
                  )}
                </>
              )}
              <div data-v-4f5f518c className="roulette_popup_btnWrap">
                <div 
                  data-v-4f5f518c 
                  className="roulette_popup_btn"
                  onClick={() => { setShowResult(false); setErrorMessage(null); setTransactionData(null); }}
                  style={{ cursor: 'pointer', background: '#28a745', color: '#fff', padding: '10px 30px', borderRadius: '25px' }}
                >
                  OK
                </div>
              </div>
              <div 
                data-v-4f5f518c 
                className="roulette_popup_close"
                onClick={() => { setShowResult(false); setErrorMessage(null); setTransactionData(null); }}
                style={{ cursor: 'pointer' }}
              >
                <div data-v-4f5f518c />
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <Footer sociallink={globalData.socialLinks || {}}/>
    </div>
    <Toolbar/>
    <Chat/>
  </div>
</div>

    )

}
export default LuckySpain;